<template>
  <div class="iframe-container">
    <div v-if="url">
      <iframe
        :src="url"
        :allowfullscreen="allowfullscreen"
        :frameborder="frameborder"
        :type="type"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    url: {
      type: String,
      required: true
    },
    frameborder: {
      type: Number,
      default: () => 0
    },
    type: {
      type: String,
      default: "text/html"
    }
  },
};
</script>

<style lang="scss" scoped>
.iframe-container {
  position: relative;
  width: 100%;
  padding-bottom: 60%;
  overflow: auto;
  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: none;
  }
}
</style>
